import {RadioTemplate} from '@service/enum/consent-enum';

export class RadioOptionModel {
    groupName: string;
    items: RadioListModel[];
    subProductTemplate?: RadioTemplate = RadioTemplate.RadioCard;
}

export class RadioListModel {
    id: string;
    name: string;
    value: string;
    heading: string;
    shortDescription?: string;
    extraInfo?: string;
    bonusInfo?: string;
    learnMore?: string;
    description?: string;
    image?: string;
    fee?: string;
    learnMoreActive?: boolean;
    isSearchData?: boolean;
    disabled?: boolean;
    minBalance?: string;
    apy?: string;
    search?: {
        label: string,
        value: any,
        searchValues: Array<Object>,
        loading: boolean
    };
    affiliatedSponsorOrganization?: string;
    hasDate?: boolean;
    derosDate?: {
        label: string,
        value: any,
        optional: true
    };
    relationShipToFamilyMember?: {
        value: any,
        optional: true
    };
    familyMemberNumber?: number;
    familyMemberFirstName?: string;
    familyMemberLastName?: string;
    hasStudentId?: boolean;
    studentId?: string;
    hasDateOfBirth?: boolean;
    familyMemberDateOfBirth?: { value: any };
    hasEmployerInput?: boolean;
    hasSponsorMemberNumber?: boolean;
    affiliatedSponsorOrganizationMemberNumber?: string;
    hasSponsorJobTitle?: boolean;
    affiliatedSponsorOrganizationEmployeeTitle?: string;
    hasBusinessNameInput?: boolean;
    businessName?: string;
    tooltip?: string;
    showPlaidBranding?: boolean;
    relation?: string;
    memberNumber?: string;
}
